import { FishGroupHeaderStyles } from './FishGroupHeader.types'

const makeStyles = (): FishGroupHeaderStyles => ({
	fishGroupHeader: {
		display: 'flex',
		justifyContent: 'space-between'
	}
})

export default makeStyles
